export const areaCourseTeachList = [
  { "code": 1, "name": "Ambiente e Saúde" },
  { "code": 2, "name": "Desenvolvimento Educacional e Social" },
  { "code": 3, "name": "Controle e Processos Industriais" },
  { "code": 4, "name": "Gestão e Negócios" },
  { "code": 5, "name": "Turismo, Hospitalidade e Lazer" },
  { "code": 6, "name": "Informação e Comunicação" },
  { "code": 7, "name": "Infraestrutura" },
  { "code": 9, "name": "Produção Alimentícia" },
  { "code": 10, "name": "Produção Cultural e Design" },
  { "code": 11, "name": "Produção Industrial" },
  { "code": 12, "name": "Recursos Naturais" },
  { "code": 13, "name": "Segurança" }
]